module.exports = __webpack_public_path__ + "static/be_cup_hero-149c080bb683483e0c6e69edac0b6f5c.jpg";